import axios from "axios";
import AxiosRequest, { API_URL } from "./instance";

export async function fetchProducts({ page, categoryId, keyword }) {
  const result = await AxiosRequest({
    url: "/merchant/products",
    method: "get",
    params: {
      page,
      categoryId,
      keyword,
    },
  });

  return result;
}

export async function updateProduct(id, payload) {
  const result = await AxiosRequest({
    url: `/merchant/product/update/${id}`,
    method: "post",
    data: payload,
  });
  return result;
}

export async function deleteProduct(id) {
  const result = await AxiosRequest({
    url: `/merchant/product/delete/${id}`,
    method: "post",
  });
  return result;
}

export async function fetchCategories() {
  const result = await AxiosRequest({
    url: "/merchant/product/categories",
    method: "get",
  });
  return result;
}

export async function login(data) {
  const result = await AxiosRequest({
    url: "/merchant/login",
    method: "post",
    data,
  });
  return result;
}

export async function openCloseAPI({ isOpen }) {
  const result = await AxiosRequest({
    url: "/merchant/update",
    method: "post",
    data: { isOpen },
  });
  return result;
}

export async function getMerchantMe() {
  const result = await AxiosRequest({
    url: "/merchant/getMerchantMe",
    method: "post",
  });
  return result;
}

export async function fetchOrders({
  statusIds = [],
  startDate,
  endDate,
  page,
  limit,
}) {
  const result = await AxiosRequest({
    url: "/merchant/fetchOrders",
    method: "post",
    data: {
      statusIds,
      startDate,
      endDate,
      page,
      limit,
    },
  });

  return result;
}

export async function fetchNewOrders() {
  const result = await AxiosRequest({
    url: "/merchant/fetchNewOrders",
    method: "post",
  });
  return result;
}

export async function fetchOrderDetails({ orderId }) {
  const result = await AxiosRequest({
    url: "/merchant/fetchOrderDetails",
    method: "post",
    data: {
      orderId,
    },
  });
  return result;
}

export async function updateOrderStatus({ orderId, statusId, prepDuration }) {
  const result = await AxiosRequest({
    url: "/merchant/updateOrderStatus",
    method: "post",
    data: {
      orderId,
      statusId,
      prepDuration,
    },
  });
  return result;
}

/**
 * Бэлтгэх хугацааг сунгах — 10 эсвэл 20 минут, захиалга тутамд 1 удаа (2026-09-17).
 * Хэрэглэгч ба жолоочид «ресторан хугацаа сунгалаа» гэж харагдана.
 */
export async function extendPrepTime({ orderId, minutes }) {
  const result = await AxiosRequest({
    url: "/merchant/order/extend-prep",
    method: "post",
    data: { orderId, minutes },
  });
  return result;
}

/**
 * Захиалгын жолооч: ирж байна / ирсэн, байршил (зөвхөн энэ ресторан руу
 * явж байгаа эсвэл ирсэн үед), зай, ойролцоо хугацаа.
 */
export async function getOrderDriver(orderId) {
  const result = await AxiosRequest({
    url: `/merchant/orders/${Number(orderId)}/driver`,
    method: "get",
  });
  return result;
}

export async function getMerchantAddress() {
  const result = await AxiosRequest({
    url: "/merchant/getMerchantAddress",
    method: "get",
  });
  return result;
}

export async function getAllDistricts() {
  const result = await AxiosRequest({
    url: "/merchant/getAllDistricts",
    method: "get",
  });
  return result;
}

export async function getPackageSizes() {
  const result = await AxiosRequest({
    url: "/merchant/getPackageSizes",
    method: "get",
  });
  return result;
}

export async function getPackagePrices(districtId) {
  const result = await AxiosRequest({
    url: `/merchant/getPackagePrices/${districtId}`,
    method: "get",
  });
  return result;
}

export async function createManualOrder(body) {
  const result = await AxiosRequest({
    url: `/merchant/create-manual-order`,
    method: "post",
    data: body,
  });
  return result;
}

export async function fetchManualOrders(body) {
  const result = await AxiosRequest({
    url: `/merchant/fetchManualOrders`,
    method: "post",
    data: body,
  });
  return result;
}

// ⚠️ Алдааг null болгож ЗАЛГИХГҮЙ — дуудагчийн try/catch нь "сүлжээ/серверийн
//    алдаа"-г "төлбөр хийгдээгүй"-ээс ялгах ёстой (qrCode.js).
export async function createQpayInvoice(body) {
  const res = await axios({
    url: `${API_URL}/createMerchantQpayInvoice`,
    method: "post",
    data: body,
  });
  return res.data;
}

export async function checkQpayPayment(body) {
  const res = await axios({
    url: `${API_URL}/checkQpayPayment`,
    method: "post",
    data: body,
  });
  return res.data;
}

export async function createProductDiscount(body) {
  const result = await AxiosRequest({
    url: "/merchant/createProductDiscount",
    method: "post",
    data: body,
  });
  return result;
}

export async function createBonusRule(body) {
  const result = await AxiosRequest({
    url: "/merchant/createBonusRule",
    method: "post",
    data: body,
  });
  return result;
}

export async function cancelProductDiscount(body) {
  const result = await AxiosRequest({
    url: "/merchant/cancelProductDiscount",
    method: "post",
    data: body,
  });
  return result;
}

export async function getMerchantDiscounts(body) {
  const result = await AxiosRequest({
    url: "/merchant/products/discount",
    method: "post",
    data: body,
  });
  return result;
}

export async function getMerchantCategories() {
  const result = await AxiosRequest({
    url: "/merchant/categories",
    method: "post",
  });
  return result;
}

export async function createMerchantCategory(body) {
  const result = await AxiosRequest({
    url: "/merchant/category/create",
    method: "post",
    data: body,
  });
  return result;
}

export const uploadCategoryImage = async (file, id) => {
  const formData = new FormData();
  formData.append("file", file);

  const result = await AxiosRequest({
    url: `/upload/image/cat/${id}`,
    method: "post",
    isForm: true,
    data: formData,
  });

  return result;
};

export async function verifyPassword(body) {
  const result = await AxiosRequest({
    url: "/merchant/password/verify",
    method: "post",
    data: body,
  });
  return result;
}

export async function deleteCategory(id) {
  const result = await AxiosRequest({
    url: `/merchant/category/delete/${id}`,
    method: "post",
  });
  return result;
}

export async function updateCategory(id, body) {
  const result = await AxiosRequest({
    url: `/merchant/category/edit/${id}`,
    method: "post",
    data: body,
  });
  return result;
}

export async function createProduct(body) {
  const result = await AxiosRequest({
    url: "/merchant/product/create",
    method: "post",
    data: body,
  });
  return result;
}

export const uploadProductImage = async (file, id) => {
  const formData = new FormData();
  formData.append("file", file);

  const result = await AxiosRequest({
    url: `/upload/image/product/${id}`,
    method: "post",
    isForm: true,
    data: formData,
  });

  return result;
};

// E24-ээс мерчантад чиглэсэн мэдээллийн баннер (зөвхөн харах)
export async function getMerchantBanners() {
  const result = await AxiosRequest({
    url: "/merchant/banners",
    method: "get",
  });
  return result;
}

/* Хэрэглэгчийн үнэлгээний жагсаалт (2026-09-18) — сүүлийнх нь эхэндээ.
   `before` — өмнөх хуудас, `after` — шинээр ирсэн. */
export async function getRatingsFeed({ before, after } = {}) {
  const params = {};
  if (before != null) params.before = before;
  if (after != null) params.after = after;
  const result = await AxiosRequest({
    url: "/merchant/ratings/feed",
    method: "get",
    params,
  });
  return result;
}

// Гүйцэтгэлийн статистик — энэ 7 хоног + өнгөрсөн 7 хоног
export async function getMerchantPerformance() {
  const result = await AxiosRequest({
    url: "/merchant/performance",
    method: "get",
  });
  return result;
}

// 7 хоногийн шилдэгт сонгогдсон featured бараануудыг татна
export async function getWeeklyFeaturedProducts() {
  return await AxiosRequest({ url: "/merchant/weekly-products", method: "get" });
}

// 7 хоногийн шилдэгт гаргах бараануудыг хадгална (max 8)
export async function saveWeeklyFeaturedProducts(productIds) {
  return await AxiosRequest({
    url: "/merchant/weekly-products",
    method: "post",
    data: { productIds },
  });
}

// ── Зураггүй барааны ТҮР (draft) зураг ───────────────────────────────────────
// Зураггүй барааг жагсаана (өөрийн зураг ч алга, каталог зураг ч алга).
export async function fetchImagelessProducts({ page = 1, pageSize = 40, keyword, onlyNoDraft } = {}) {
  return await AxiosRequest({
    url: "/merchant/imageless-products",
    method: "get",
    params: { page, pageSize, keyword, onlyNoDraft },
  });
}

// Барааг аппаас хасах (soft-delete, is_deleted=1, буцаах боломжтой).
export async function removeDraftProduct(productId) {
  return await AxiosRequest({
    url: `/merchant/draft-remove/${productId}`,
    method: "post",
  });
}

// Баркод уншуулаад тухайн дэлгүүрийн барааг олно (скан → productId).
export async function lookupDraftProduct(barcode) {
  return await AxiosRequest({
    url: `/merchant/draft-product-lookup/${encodeURIComponent(barcode)}`,
    method: "get",
  });
}

// Утаснаас авсан зургийг draft болгож хадгална. Талбарын нэр ЗААВАЛ "image"
// (backend singleImage) — уул нь `uploadProductImage` нь "file" ашигладгаас ЯЛГААТАЙ.
export async function uploadDraftImage(file, productId) {
  const formData = new FormData();
  formData.append("image", file);
  return await AxiosRequest({
    url: `/merchant/draft-images/${productId}`,
    method: "post",
    isForm: true,
    data: formData,
  });
}
